/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Kevin Zuccaro",
  title: "Hi all, I'm Kevin",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Dart / Flutter / Php and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1_ZfG11IuQuKgum2JKJThGefRdwdqrN_T/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/KevinZuccaro",
  linkedin: "https://www.linkedin.com/in/kevinzuccaro/",
  gmail: "kevin@zuccaro.eu.org",
  facebook: "https://www.facebook.com/Zuccaroevin/",
  instagram: "http://instagram.com/kevinzuccaro._/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Dart",
      fontAwesomeClassname: "fab fa-dart-lang"
    },
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fab fa-flutter"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "ITT G. GIORGI",
      logo: require("./assets/images/LogoGiorgi.jpeg"),
      subHeader: "Information Technology and Telecommunications",
      duration: "September 2020 - Present",
      desc: "Specific skills in the field of computer systems, information processing, web applications and technologies, networks, and communication devices. Competencies and knowledge that, depending on the various specializations, focus on the analysis, design, installation, and management of computer systems, processing system networks, multimedia systems, and signal transmission and reception devices. Oriented towards managing the application lifecycle, which can be applied to software: management, service-oriented, or for dedicated 'embedded' systems. Collaboration in project management, operating within the framework of national and international regulations, concerning security in all its aspects and information protection (privacy). Some of the activities completed between school courses and PCTO experiences:",
      descBullets: [
        "March 10, 2022: Participated in the Reply Code Challenge - Teen Edition, ranking 100th in the global leaderboard.",
        "School Year 2022/23: Participated in the 'Code Academy and Team-based Computer Science Olympiad' project organized by ITT G. GIORGI, for a total of 24 hours.",
        "November 22 - March 23: Participated in the online course 'AI FOR YOUTH STUDENT' organized by CERTIPASS, totaling 25 hours. The course covered topics such as 'Introduction - ARC Synthiam Platform.",
        "December 14, 2023: Participated in the XXVIII Italian Physics Championships and won first place in the School Phase.",
        "February 23 - May 23: Participated in the 'CyberChallenge 2023' course, promoted by the Department of Innovation Engineering at the University of Salento."
      ],
      footerLink: [
        {
          name: "Website",
          url: "https://ittgiorgi.edu.it"
        }
      ]
    },
    {
      schoolName: "OpenEDG Python Institute with Cisco Networking Academy",
      logo: require("./assets/images/logoPython.png"),
      subHeader: "PYTHON ESSENTIALS 1",
      duration: "April 2023",
      desc: "The course covered and certified the following topics:",
      descBullets: [
        "Design, develop, debug, execute, and refactor simple computer programs written in Python 3.",
        "Think algorithmically to analyze problems and implement them as computer processes.",
        "Use the syntax, semantics, and the most important elements of the Python Standard Library to write Python scripts",
        "and resolve typical implementation challenges.",
        "Understand the role of a programmer in the software development process."
      ],
      footerLink: [
        {
          name: "See Certificate",
          url: "https://drive.google.com/file/d/1QWEhFcbATU3OfrPqWrw0sz6PQVLzhYPi/view?usp=sharing"
        }
      ]
    },
    {
      schoolName: "CertiPass",
      logo: require("./assets/images/logoCertipass.png"),
      subHeader: "AI FOR YOUTH STUDENT",
      duration: "March 2023",
      desc: "The course covered and certified the following topics:",
      descBullets: [
        "Introduction to AI.",
        "Piattaforma ARC Synthiam.",
      ],
      footerLink: [
        {
          name: "See Certificate",
          url: "https://drive.google.com/file/d/1L3wbIqdqqCrChWIOAXD8tJXumM6FWGUL/view?usp=sharing"
        }
      ]
    },
    {
      schoolName: "Accademia del Levante with Cisco Networking Academy",
      logo: require("./assets/images/logoLevante.png"),
      subHeader: "CYBERSECURITY ESSENTIALS",
      duration: "December 2022",
      desc: "The course covered and certified the following topics:",
      descBullets: [
        "Describe the tactics, techniques and procedures used by cyber criminals.",
        "Describe the principles of confidentiality, integrity, and availability as they relate to data states and cybersecurity countermeasures.",
        "Describe technologies, products and procedures used to protect confidentiality, ensure integrity and provide high availability.",
        "Explain how cybersecurity professionals use technologies, processes and procedures to defend all components of the network.",
        "Explain the purpose of laws related to cybersecurity."
      ],
      footerLink: [
        {
          name: "See Certificate",
          url: "https://drive.google.com/file/d/1U8QKpst99-G-pEbWdvEI-MZQKcp-2Fe3/view?usp=sharing"
        }
      ]
    },
    {
      schoolName: "Accademia del Levante with OpenEDG JavaScript Institute",
      logo: require("./assets/images/logoJS1.png"),
      subHeader: "JAVASCRIPT ESSENTIALS 1 (JSE)",
      duration: "April 2022",
      desc: "The course covered and certified the following topics:",
      descBullets: [
        "Knows the syntax of the core JavaScript language to a degree that allows them to work with variables, operators, control flow, and functions;",
        "Knows the basics of the JavaScript data types system, distinguishing between primitive and complex types, and is able to choose a type adequate to their needs;",
        "Thinks algorithmically and can analyze a problem using a programmatic conceptual apparatus;",
        "Knows how a program is interpreted and executed in an actual computer environment, and can design, develop, and improve very simple JavaScript programs;",
        "Can interpret and handle basic exceptions related to errors in program execution;",
        "Understands a programmer’s work in the software development process, and the role of fundamental development tools.",
      ],
      footerLink: [
        {
          name: "See Certificate",
          url: "https://drive.google.com/file/d/1dvy-QTlk1_jHXUkRkzvybAd9jNUEYga2/view?usp=sharing"
        }
      ]
    },
    {
      schoolName: "Cisco Networking Academy",
      logo: require("./assets/images/ciscoLogo.png"),
      subHeader: "NDG LINUX ESSENTIALS",
      duration: "June 2021",
      desc: "The course covered and certified the following topics:",
      descBullets: [
        "Understand the Linux operating system;",
        "Have demonstrated the ability to navigate a Linux system;",
        "Can execute the power of the Linux command line;",
        "Possess knowledge of Linux security and file permissions.",
      ],
      footerLink: [
        {
          name: "See Certificate",
          url: "https://drive.google.com/file/d/186coe_Ej-Wy7d5mCUDmhQMlYt4OaoADf/view?usp=sharing"
        }
      ]
    },
    {
      schoolName: "Cisco Networking Academy",
      logo: require("./assets/images/ciscoLogo.png"),
      subHeader: "NDG LINUX UNHATCHED",
      duration: "May 2021",
      desc: "The course covered and certified the following topics:",
      descBullets: [
      ],
      footerLink: [
        {
          name: "See Certificate",
          url: "https://drive.google.com/file/d/1NmyOUaW7b4ulyG3gQyYuSriCzfdGJgvL/view?usp=sharing"
        }
      ]
    },
    {
      schoolName: "Cisco Networking Academy with Accademia del Levante",
      logo: require("./assets/images/ciscoLogo.png"),
      subHeader: "Introduction to CyberSecurity",
      duration: "November 2022",
      desc: "The course covered and certified the following topics:",
      descBullets: [
        "Global implications of cyber threats",
        "Ways in which networks are vulnerable to attack",
        "Impact of cyber-attacks on industries",
        "Cisco’s approach to threat detection and defense",
        "Why cybersecurity is a growing profession",
        "Opportunities available for pursuing network security certifications",
      ],
      footerLink: [
        {
          name: "See Certificate",
          url: "https://drive.google.com/file/d/1hB1DuTjpglVQbiWD2MhCHK1ez-xOcPju/view?usp=sharing"
        }
      ]
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Mobile",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full-Stack Developer",
      company: "SolarGreen SRL",
      companylogo: require("./assets/images/logoSolarGreen.png"),
      date: "October 2023 – Present",
      desc: "Responsible for designing, developing, managing, and maintaining the company's website and servers, ensuring optimal performance, security, and reliability.",
      descBullets: [
        "Site web: https://solargreen.srl"
      ]
    },
    {
      role: "Enterprise Software Developer",
      company: "Luxury Life Fitness",
      companylogo: require("./assets/images/logoLuxuryFitness.png"),

      date: "May 2022 – Present",
      desc: "Software for managing gym members, including tracking membership renewals and the expiration of medical certificates, ensuring efficient administration and compliance with health regulations.",
      descBullets: [
        "For more information about the product and to request a demo, please contact"
      ]
    },

    {
      role: "E-commerce Web Developer",
      company: "Boutique Usato Nuovo",
      companylogo: require("./assets/images/logoBoutique.png"),

      date: "March 2024 – Present",
      desc: "Creation and management of an e-commerce platform for a local business, including the development of the online sales platform, integration with payment and shipping systems, and optimization of the user experience."
    },

  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "My projects",
  subtitle: "SOME OF MY PERSONAL PROJECTS",
  projects: [
    {
      image: require("./assets/images/rd_brindisi.png"),
      projectName: "Raccolta Differenziata - BR",
      projectDesc: "App designed to remind users of the scheduled recycling collection days in the province of Brindisi.",
      footerLink: [
        {
          name: "Mobile App"
        },
        {
          name: "Visit Play Store",
          url: "https://play.google.com/store/apps/details?id=com.zuccaro.rd_mesagne/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/appNing.png"),
      projectName: "Ning: Network Scanner",
      projectDesc: "Ning: Network Scanner – A comprehensive tool for detecting and analyzing network devices.",
      footerLink: [
        {
          name: "Mobile App"
        },
        {
          name: "Visit Play Store",
          url: "https://play.google.com/store/apps/details?id=com.zuccaro.ning/"
        }
      ]
    },
    {
      image: require("./assets/images/appSpese.png"),
      projectName: "Manage your Expenses",
      projectDesc: "Manage your Expenses - is an intuitive, ad-free application designed to help you manage your expenses easily and efficiently. With Manage your Expenses, you can track your personal finances without complications and focus on building healthy financial habits.",
      footerLink: [
        {
          name: "Mobile App"
        },
        {
          name: "Visit Play Store",
          url: "https://play.google.com/store/apps/details?id=com.zuccaro.spese/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Get Connected - Cisco Networking Academy",
      subtitle:
        "Identifying different types of computer systems, internal components, and external devices. Understanding the directory structure in Microsoft Windows and working with files and folders using a text editor. Gaining knowledge of computer networks, browsers, internet search, and email usage. Creating and managing various social media accounts, including Facebook, LinkedIn, and YouTube. Identifying common issues and implementing simple solutions for hardware, software, and networks.",
      image: require("./assets/images/ciscoLogo.png"),
      imageAlt: "Cisco Academy Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1ijDflNNEhiIWT8Oy56KEvlDq7WPdGqMW/view?usp=share_link"
        }
      ]
    },
    
    {
      title: "Introduction to CyberSecurity - Cisco Networking Academy",
      subtitle:
        "Global implications of cyber threats, ways in which networks are vulnerable to attack, the impact of cyber-attacks on industries, Cisco’s approach to threat detection and defense, the growing importance of cybersecurity as a profession, and opportunities for pursuing network security certifications.",
      image: require("./assets/images/ciscoLogo.png"),
      imageAlt: "Cisco Academy Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1ojCPVTjphdvQRltb_TsmylsygOoL5XzP/view?usp=share_link"
        }
      ]
    },
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+39 3513779598",
  email_address: "kevin@zuccaro.eu.org"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
